var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,2h-1.5V.5c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v1.5H7V.5c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v1.5h-1.5C2.019,2,0,4.019,0,6.5v13c0,2.481,2.019,4.5,4.5,4.5h15c2.481,0,4.5-2.019,4.5-4.5V6.5c0-2.481-2.019-4.5-4.5-4.5ZM4.5,3h15c1.93,0,3.5,1.57,3.5,3.5v1.5H1v-1.5c0-1.93,1.57-3.5,3.5-3.5Zm15,20H4.5c-1.93,0-3.5-1.57-3.5-3.5V9H23v10.5c0,1.93-1.57,3.5-3.5,3.5Zm-2.5-11.5v2.5c0,.552-.448,1-1,1h-2.5c-.276,0-.5-.224-.5-.5s.224-.5,.5-.5h1.957c-.706-1.217-2.015-2-3.457-2-1.692,0-3.209,1.072-3.772,2.667-.093,.262-.375,.398-.639,.305-.26-.092-.396-.377-.305-.638,.705-1.994,2.601-3.333,4.716-3.333,1.6,0,3.072,.768,4,2.004v-1.504c0-.276,.224-.5,.5-.5s.5,.224,.5,.5Zm-.284,6.167c-.705,1.994-2.601,3.333-4.716,3.333-1.6,0-3.072-.768-4-2.004v1.504c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5v-2.5c0-.552,.448-1,1-1h2.5c.276,0,.5,.224,.5,.5s-.224,.5-.5,.5h-1.957c.706,1.217,2.015,2,3.457,2,1.692,0,3.209-1.072,3.772-2.667,.093-.261,.377-.396,.639-.305,.26,.092,.396,.377,.305,.638Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarUpdate);
export default __webpack_public_path__ + "static/media/calendar-update.e6efac579ed854c69be7e5d34cdcb74a.svg";
export { ForwardRef as ReactComponent };